import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Icon,
  Button
} from 'semantic-ui-react'

const ModConsultAppointmentListUX = (props: any) => {
    return(
      <div
        style={{padding: "20px"}}>
        <div
          style={{display: "flex",  justifyContent: "space-between"}}>
          
          <div
            style={{color: "#0D71BB", fontSize: "18px", fontWeight: "bold"}}>
            {props.languageUX === "en" ? "List of other patients in the same period" : "รายชื่อผู้ป่วยอื่นๆในคาบเดียวกัน"}
          </div>
          <div
            style={{marginTop: "-15px"}}>
            
            <Icon
              className="large red"
              name="close"
              onClick={props.onClose}>
            </Icon>
          </div>
        </div>
        <hr>
        </hr>
        <div>
          
          <Table
            data={props.data}
            getTrProps={props.onRowClick}
            headers="รายชื่อผู้ป่วย,เวลาเริ่ม,ระยะเวลา,ผู้ทำนัดหมาย,วันเวลาที่ทำนัดหมาย"
            keys="patient_full_name,start_time,duration,appointment_user,booking_date_time"
            minRows={10}
            pageSize={10}
            showPagination={false}
            widths="300,150,150">
          </Table>
        </div>
        <div
          style={{display: props.showActionButton ? "flex" : "none", justifyContent: "flex-end", alignItems: "center", padding: "10px"}}>
          
          <Button
            color="green"
            onClick={props.onConfirmAppointment}
            style={{...(props.hideConfirmButton? {display: "none"}: {})}}>
            {props.languageUX === "en" ? "Confirm appointment" : "ยืนยันนัดหมาย"}
          </Button>
          <Button
            color="yellow"
            onClick={props.onEditAppointmentDateTime}>
            {props.languageUX === "en" ? "Modify appointment date and time" : "แก้ไขวันเวลานัดหมาย"}
          </Button>
          <Button
            color="red"
            onClick={props.onCancelAppointment}>
            {props.languageUX === "en" ? "Cancel an appointment" : "ยกเลิกนัดหมาย"}
          </Button>
        </div>
      </div>
    )
}


export default ModConsultAppointmentListUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{padding: \"20px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "hr",
      "parent": 0,
      "props": {
      },
      "seq": 3,
      "void": true
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 3,
      "props": {
        "data": {
          "type": "code",
          "value": "props.data"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onRowClick"
        },
        "headers": {
          "type": "value",
          "value": "รายชื่อผู้ป่วย,เวลาเริ่ม,ระยะเวลา,ผู้ทำนัดหมาย,วันเวลาที่ทำนัดหมาย"
        },
        "keys": {
          "type": "value",
          "value": "patient_full_name,start_time,duration,appointment_user,booking_date_time"
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "pageSize": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": "300,150,150"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",  justifyContent: \"space-between\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "รายชื่อผู้ป่วยอื่นๆในคาบเดียวกัน",
          "valueEN": "List of other patients in the same period"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#0D71BB\", fontSize: \"18px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"-15px\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Icon",
      "parent": 7,
      "props": {
        "className": {
          "type": "value",
          "value": "large red"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: props.showActionButton ? \"flex\" : \"none\", justifyContent: \"flex-end\", alignItems: \"center\", padding: \"10px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยันนัดหมาย",
          "valueEN": "Confirm appointment"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "onClick": {
          "type": "code",
          "value": "props.onConfirmAppointment"
        },
        "style": {
          "type": "code",
          "value": "{...(props.hideConfirmButton? {display: \"none\"}: {})}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไขวันเวลานัดหมาย",
          "valueEN": "Modify appointment date and time"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "onClick": {
          "type": "code",
          "value": "props.onEditAppointmentDateTime"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกนัดหมาย",
          "valueEN": "Cancel an appointment"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelAppointment"
        }
      },
      "seq": 12,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "ModConsultAppointmentListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
